/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutocompleteAddressResponseBaseResponse as ModelsCustomerAutocompleteAddressResponseBaseResponse } from '../../models/Models/Customer/autocomplete-address-response-base-response';

export interface V4PublicApplicationApplicationIdGetAddressAutocompleteGet$Json$Params {
  query?: string;
  applicationId: string;
}

export function v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Json(http: HttpClient, rootUrl: string, params: V4PublicApplicationApplicationIdGetAddressAutocompleteGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerAutocompleteAddressResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Json.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.path('applicationId', params.applicationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerAutocompleteAddressResponseBaseResponse>;
    })
  );
}

v4PublicApplicationApplicationIdGetAddressAutocompleteGet$Json.PATH = '/v4/public/application/{applicationId}/getAddressAutocomplete';
